(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(5075);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var _helpers_generateOgImages_generateOgImages__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5247);
/* harmony import */ var _mappers_MapComponents_MapComponents__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5153);
/* harmony import */ var _organisms_PreviewModeOverlay_PreviewModeOverlay__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7707);
/* harmony import */ var _context_PageContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3032);
/* Dependencies */ 

// Helpers

// Components



/**
 * Home Page
 * @param props - Required page props.
 * @returns
 */ var Home = function(param) {
    var _fields = param.fields, title = _fields.title, seo = _fields.seo, components = _fields.components, preview = param.preview;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            seo && seo.fields && !seo.fields.hideFromSeo && seo.fields.title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
                title: "MMT | ".concat(seo.fields.title),
                description: seo.fields.description,
                openGraph: {
                    title: seo.fields.openGraphTitle || seo.fields.title,
                    description: seo.fields.openGraphDescription || seo.fields.description,
                    images: (0,_helpers_generateOgImages_generateOgImages__WEBPACK_IMPORTED_MODULE_5__/* .generateOgImages */ .W)(seo)
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_context_PageContext__WEBPACK_IMPORTED_MODULE_4__/* .PageContext.Provider */ .z.Provider, {
                value: {
                    pageTitle: title
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mappers_MapComponents_MapComponents__WEBPACK_IMPORTED_MODULE_2__/* .MapComponents */ .n, {
                    components: components
                })
            }),
            preview && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_organisms_PreviewModeOverlay_PreviewModeOverlay__WEBPACK_IMPORTED_MODULE_3__/* .PreviewModeOverlay */ .K, {})
        ]
    });
};
var __N_SSG = true;
// Exports
/* harmony default export */ __webpack_exports__["default"] = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [549,961,774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);